export default __webpack_public_path__ + "static/media/twitter.10ef6b7b.svg";